import { render, staticRenderFns } from "./FormularioFallaRespuestas.vue?vue&type=template&id=67741b5e&scoped=true&lang=pug"
import script from "./FormularioFallaRespuestas.vue?vue&type=script&lang=js"
export * from "./FormularioFallaRespuestas.vue?vue&type=script&lang=js"
import style0 from "./FormularioFallaRespuestas.vue?vue&type=style&index=0&id=67741b5e&prod&lang=css"
import style1 from "./FormularioFallaRespuestas.vue?vue&type=style&index=1&id=67741b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67741b5e",
  null
  
)

export default component.exports